import React from 'react';

export type ClinicTextInputProps = {
  label: string;
  value: string;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  onChange: (value: string) => void;
  error?: string;
  className?: string;
  id?: string;
  name?: string;
};

export const ClinicTextInput: React.FC<ClinicTextInputProps> = ({
  label,
  value,
  placeholder = '',
  type = 'text',
  onChange,
  error,
  className = '',
  id,
  name,
}) => {
  const inputId = id || name || label.replace(/\s+/g, '-').toLowerCase();

  return (
    <div className={className}>
      <label
        htmlFor={inputId}
        className='block text-sm font-medium mb-2'
        style={{ color: 'var(--clinic-text-secondary)' }}
      >
        {label}
      </label>
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        className={`w-full px-0 py-2 bg-transparent border-0 border-b focus:ring-0 focus:outline-none transition-colors placeholder:opacity-70 ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
        style={
          {
            color: 'var(--clinic-text)',
            borderBottomColor: error ? undefined : 'rgba(255,255,255,0.6)',
            // Tailwind's placeholder color via inline style for theme variable
            // This is complemented by a global utility in CSS for cross-browser
            // but here we ensure it uses the same variable.
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - CSS custom property for placeholder via style maps in modern browsers
            '::placeholder': { color: 'var(--clinic-text)' },
            '--tw-ring-color': 'var(--clinic-primary)',
          } as React.CSSProperties
        }
        placeholder={placeholder}
      />
      {error && <p className='text-red-500 text-sm mt-1'>{error}</p>}
    </div>
  );
};

export default ClinicTextInput;
